export default __webpack_public_path__ + "static/media/Bloodseer's Armbands.149806b1.jpg";